module.exports = __webpack_public_path__ + "static/media/co.41244c20.svg";